import { render } from "./DataBlog.vue?vue&type=template&id=72f6ccae"
import script from "./DataBlog.vue?vue&type=script&lang=js"
export * from "./DataBlog.vue?vue&type=script&lang=js"

import "./DataBlog.vue?vue&type=style&index=0&id=72f6ccae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__